import React, { useState, useEffect } from "react";
import {
	Typography,
	Flex,
} from "antd";
import {
	ArrowLeftOutlined,
} from "@ant-design/icons";
import { sellBoostFetch } from "../../utlifyFunction";
import DescriptionModal from "../../components/Modals/DescriptionModal";
import ShopifyProducts from "../../components/ShopifyProducts";
import SEOOptimizerModal from "../../components/Modals/SEOOptimizerModal";

const { Title } = Typography;

export default function Products() {
	const [products, setProducts] = useState(null);
	const [filteredProducts, setFilteredProducts] = useState(null);
	const [modalVisible, setModalVisible] = useState(false);
	const [showSEOModal, setShowSEOModal] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [newDescription, setNewDescription] = useState("");

	const fetchProducts = async () => {
		setFilteredProducts(null);
		const data = await sellBoostFetch("POST", "/shopify/fetchProducts");
		setProducts(data?.products || []);
		setFilteredProducts(data?.products || []);
	};

	const openModal = (product) => {
		console.log(product);
		setSelectedProduct(product);
		setNewDescription("");
		setModalVisible(true);
	};

	const openSEOModal = (product) => {
		setSelectedProduct(product);
		setShowSEOModal(true);
	};
	const handleSearch = (value) => {
		if (!products) return;
		console.log(value,products);

		const filtered = products.filter((node) =>
			node.title.toLowerCase().includes(value.toLowerCase())
		);
		console.log(filtered)
		setFilteredProducts(filtered);
	};

	// Handle sorting by product name
	const handleSort = (order) => {
		if (!filteredProducts) return;

		const sorted = [...filteredProducts].sort((a, b) => {
			if (order === "asc") {
				return a?.title?.localeCompare(b.title);
			} else {
				return b?.title?.localeCompare(a.title);
			}
		});
		setFilteredProducts(sorted);
	};

	useEffect(() => {
		fetchProducts();
	}, []);

	return (
		<div >
			{showSEOModal ? (
				<div>
					<Flex
						align="center"
						gap={"8px"}
						style={{ marginBottom: "20px", cursor: "pointer" }}
						onClick={() => setShowSEOModal(false)}
					>
						<ArrowLeftOutlined />
						<Title level={4} style={{ margin: 0 }}>
							Products
						</Title>
					</Flex>
					<SEOOptimizerModal selectedProduct={selectedProduct} />
				</div>
			) : (
				<React.Fragment>
					<ShopifyProducts
						products={filteredProducts}
						openModal={openModal}
						onSort={handleSort}
						onSearch={handleSearch}
						fetchProducts={fetchProducts}
						openSEOModal={openSEOModal}
					/>
					{modalVisible && (
						<DescriptionModal
							modalVisible={modalVisible}
							setModalVisible={setModalVisible}
							selectedProduct={selectedProduct}
							newDescription={newDescription}
							setNewDescription={setNewDescription}
							fetchProducts={fetchProducts}
						/>
					)}
				</React.Fragment>
			)}
		</div>
	);
}
